<div [class]="['cerrix-form-field', disabled ? 'disabled' : '']">
    <div class="color-container">
        <input
            class="color-input"
            type="color"
            [disabled]="disabled"
            [ngModel]="value"
            [attr.data-uiid]="dataUiid + '-color-input'"
            (input)="onChange($event)"
        />

        <div
            [class]="[
                'color-text-container',
                '#' + colorTextForm.value !== value ? 'unused-color' : '',
            ]"
        >
            #<input
                class="color-text-input"
                type="text"
                [attr.data-uiid]="dataUiid + '-color-text-input'"
                [formControl]="colorTextForm"
                (input)="onColorTextChange($event)"
            />
        </div>
    </div>
    <div class="predefined-colors">
        @for (color of predefinedColors; track color) {
            <div
                (click)="onPredefinedSelection(color)"
                [class]="['predefined-color', color === value ? 'selected' : '']"
                [attr.data-uiid]="dataUiid + '-predefined-color-' + color"
                [style.backgroundColor]="color"
            ></div>
        }
    </div>

    @if (ngControl?.control?.errors) {
        <div class="cerrix-form-field-error-wrapper">
            @for (error of ngControl!.control!.errors | errorMessages; track error) {
                <div class="form-field-error">
                    {{ error }}
                </div>
            }
        </div>
    }
</div>
